module.exports = __webpack_public_path__ + "static/media/Le-Chapeau.9e5cf7c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/Le-Chapeau.jpg
// module id = 429
// module chunks = 0